import { render, staticRenderFns } from "./doggy-packs-details-page.vue?vue&type=template&id=bda89902&scoped=true&lang=pug"
import script from "./doggy-packs-details-page.js?vue&type=script&lang=js&external"
export * from "./doggy-packs-details-page.js?vue&type=script&lang=js&external"
import style0 from "./doggy-packs-details-page.vue?vue&type=style&index=0&id=bda89902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda89902",
  null
  
)

export default component.exports